export default "__VITE_ASSET__BJy3eIrJ__"